import { JobRecord, WithUriAlias } from 'core/interfaces'

export const jobLink = (job: JobRecord | WithUriAlias): string => `/jobs/${job.pathname}`

export const newsfeedLink = ({ pathname }: WithUriAlias): string => `/newsfeed/${pathname}`
